<template>
    <div class="Exempt"> 
        <van-nav-bar :title="this.$t('免审参数')" left-arrow safe-area-inset-top style="background-color: #1ABC9C;" @click-left="goto"/>
        
        <div class="form-container">
            <!-- 自动授权截止时间 -->
            <div class="form-item">
                <label class="form-label">{{this.$t('自动授权截止时间')}}</label>
                <van-field
                    v-model="autoAuthEndTime"
                    :placeholder="this.$t('请选择日期')"
                    readonly
                    :disabled="!autoAuthSwitch"
                    @click="autoAuthSwitch && (showDatePicker = true)"
                    class="form-input"
                />
            </div>
            
            <!-- 自动授权口令 -->
            <div class="form-item">
                <label class="form-label">{{this.$t('自动授权口令')}}</label>
                <van-field
                    v-model="autoAuthPassword"
                    type="text"
                    :placeholder="this.$t('请输入口令')"
                    :disabled="!autoAuthSwitch"
                    class="form-input"
                />
            </div>
            
            <!-- 自动授权开关 -->
            <div class="form-item">
                <label class="form-label">{{this.$t('自动授权开关')}}</label>
                <van-switch
                    v-model="autoAuthSwitch"
                    size="24"
                    active-color="#1ABC9C"
                    inactive-color="#ddd"
                />
            </div>
            
            <!-- 确认按钮 -->
            <van-button 
                type="primary" 
                block 
                class="confirm-btn"
                @click="handleConfirm"
            >
                {{this.$t('qr')}}
            </van-button>
        </div>
        
        <!-- 日期选择器 -->
        <van-popup v-model="showDatePicker" position="bottom" >
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                :confirm-button-text="this.$t('qr')"
                :cancel-button-text="this.$t('qx')"
                :title="this.$t('选择日期')"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="onDateConfirm"
                @cancel="showDatePicker = false"
            />
        </van-popup>
    </div>
    
</template>
<script>
import { Toast } from 'vant';
import { DatetimePicker } from 'vant';
export default {
    data() {
        return {
            autoAuthEndTime: '',      // 显示用的日期字符串 (YYYY-MM-DD)
            autoAuthEndTimeStamp: '', // 提交用的时间戳
            autoAuthPassword: '',
            autoAuthSwitch: false,
            showDatePicker: false,
            currentDate: '',
            minDate: new Date(),
            maxDate: new Date(Date.now() + 10 * 365 * 24 * 60 * 60 * 1000) // 10年后
        }
    },
    mounted() {
        this.loadAutoKeySettings();
    },
    methods: {
        async loadAutoKeySettings() {
            try {
                const params = {
                    method: 'co.device.auto.key.get',
                    id: this.$route.query.deviceId
                };
                
                const res = await this.$serve2(params);
                if (res.data.code === 0) {
                    const data = res.data.data;
                    
                    // 设置开关状态 (0: 关闭, 1: 开启)
                    this.autoAuthSwitch = data.is_open_auto_key === '1' || data.is_open_auto_key === 1;
                    
                    // 设置口令
                    this.autoAuthPassword = data.auto_password || '';
                    
                    // 设置截止时间（时间戳转日期格式）
                    // auto_key_time 为 0 表示未设置
                    if (data.auto_key_time && data.auto_key_time !== 0) {
                        this.autoAuthEndTimeStamp = data.auto_key_time;
                        const date = new Date(data.auto_key_time * 1000);
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        this.autoAuthEndTime = `${year}-${month}-${day}`;
                    } else {
                        this.autoAuthEndTime = '';
                        this.autoAuthEndTimeStamp = '';
                    }
                }
            } catch (err) {
                console.error('获取自动授权设置失败:', err);
            }
        },
        goto() {
            // 判断是否有上一页
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                // 如果没有上一页，返回首页
                this.$router.push('/');
            }
        },
        onDateConfirm(date) {
            // 保存显示用的日期字符串 (YYYY-MM-DD)
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            this.autoAuthEndTime = `${year}-${month}-${day}`;
            
            // 保存提交用的时间戳（当天最后一秒）
            const endOfDay = new Date(year, month - 1, day, 23, 59, 59);
            this.autoAuthEndTimeStamp = Math.floor(endOfDay.getTime() / 1000);
            
            this.showDatePicker = false;
        },
        async handleConfirm() {
           
            // 构造请求参数
            let params = {
                method: 'co.device.auto.key.set',
                id:this.$route.query.deviceId,
                auto_key_time: this.autoAuthEndTimeStamp,
                auto_password: this.autoAuthPassword,
                is_open_auto_key: this.autoAuthSwitch ? '1' : '0'
            };
            
            // 发送请求
            await this.$serve2(params).then(res => {
                if (res.data.code === 0) {
                    Toast.success('设置成功');
                    // this.$router.go(-1);
                } else {
                    Toast.fail(res.data.message || '设置失败');
                }
            }).catch(err => {
                Toast.fail('请求失败');
            });
        }
    }
}
</script>
<style scoped>
.Exempt {
    min-height: 100vh;
    background-color: #f5f5f5;
}

.Exempt>>>.van-nav-bar__title {
    color: #fff;
}

.Exempt>>>.van-nav-bar .van-icon {
    color: #fff;
}

.form-container {
    padding: 20px;
    margin-top: 10px;
}

.form-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    padding: 15px 16px;
    margin-bottom: 1px;
}

.form-label {
    font-size: 15px;
    color: #333;
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 15px;
    text-align: left;
    width: 120px;
}

.form-input {
    text-align: right;
}

.form-input .van-field__control {
    text-align: right;
    font-size: 15px;
    color: #666;
}

.confirm-btn {
    margin-top: 30px;
    background-color: #1ABC9C;
    border-radius: 8px;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
}

.confirm-btn::after {
    border: none;
}
</style>
